import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/png/stages_of_scaling.png'


const _withScopeId = n => (_pushScopeId("data-v-53cb0b3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-lg container-fluid shadow-sm py-3" }
const _hoisted_2 = { ref: "innovation1" }
const _hoisted_3 = { class: "text-primary" }
const _hoisted_4 = {
  key: 0,
  class: "mb-1"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Program Area : ", -1))
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Sub Program Area : ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-primary" }, [
  /*#__PURE__*/_createTextVNode(" A. Categories "),
  /*#__PURE__*/_createElementVNode("small", { class: "span_color d-none" }, "What type of innovation are you submitting?")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-danger mx-1" }, "*", -1))
const _hoisted_12 = ["for"]
const _hoisted_13 = { class: "d-none" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-danger mx-1" }, "*", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-secondary" }, "(select at least one option)", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = { class: "field-checkbox" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "reproductive" }, "Reproductive, maternal, newborn and child health", -1))
const _hoisted_19 = { class: "d-none p-float-label prime_input" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "other" }, "Others ", -1))
const _hoisted_21 = { class: "pb-3 section_b" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-primary" }, [
  /*#__PURE__*/_createTextVNode(" B. Solution Details "),
  /*#__PURE__*/_createElementVNode("small", { class: "span_color" }, "(Information required to describe and demonstrate the solution)")
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_24 = { class: "p-float-label prime_input" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "title" }, [
  /*#__PURE__*/_createTextVNode("Name/Title of solution "),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "description" }, [
  /*#__PURE__*/_createTextVNode("Describe the solution and how it addresses/solves the problem described above. In your description please provide solution/product details or specifications (250 words max)"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger mx-1" }, "*")
], -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "innovative" }, [
  /*#__PURE__*/_createTextVNode("How is the solution innovative (250 words max)"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger mx-1" }, "*")
], -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "similar" }, "If there are similar solutions available, what differentiates the solution from the others (250 words max)", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "my-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "stages of scaling",
    class: "img-fluid"
  })
], -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "solution" }, [
  /*#__PURE__*/_createTextVNode("Stage of solution development "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger mx-1" }, "*")
], -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "clinical" }, "Stage of clinical development (if applicable)", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "subject" }, [
  /*#__PURE__*/_createTextVNode("Solution subject to regulatory requirements?"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger mx-1" }, "*")
], -1))
const _hoisted_33 = { key: 0 }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "requirement" }, [
  /*#__PURE__*/_createTextVNode("Please select the regulatory requirements for the solution"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger mx-1" }, "*")
], -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "regulatoryReqOthers" }, "If Other selected, please describe (250 words max)", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "status" }, [
  /*#__PURE__*/_createTextVNode("Please select status of regulatory requirement of solution."),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger mx-1" }, "*")
], -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "fund" }, [
  /*#__PURE__*/_createTextVNode("What funds have been raised to date, or what is organisation turnover?"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger mx-1" }, "*")
], -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "employee" }, [
  /*#__PURE__*/_createTextVNode("How many paid employees work to support the product/solution. Please describe roles as well. (250 words max)"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger mx-1" }, "*")
], -1))
const _hoisted_39 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_BaseFileLong = _resolveComponent("BaseFileLong")!
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.needDetails?.programArea)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("u", null, _toDisplayString(_ctx.needDetails?.programArea), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.needDetails?.subProgramArea)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("small", null, [
                  _hoisted_7,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.needDetails.subProgramArea, (el, i) => {
                    return (_openBlock(), _createElementBlock("span", { key: i }, _toDisplayString(el.name) + ",  ", 1))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _hoisted_8,
        _hoisted_9,
        _hoisted_10,
        _createElementVNode("ol", null, [
          _createElementVNode("li", null, [
            _createTextVNode(" What type of innovation are you submitting?"),
            _hoisted_11,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.information, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item,
                class: "field-checkbox"
              }, [
                _createVNode(_component_Checkbox, {
                  id: item,
                  name: "item",
                  value: item,
                  modelValue: _ctx.form.selectedInformation,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.selectedInformation) = $event))
                }, null, 8, ["id", "value", "modelValue"]),
                _createElementVNode("label", { for: item }, _toDisplayString(item), 9, _hoisted_12)
              ]))
            }), 128))
          ]),
          _createElementVNode("li", _hoisted_13, [
            _createTextVNode(" Which area(s) does your innovation cover?"),
            _hoisted_14,
            _hoisted_15,
            _hoisted_16,
            _createVNode(_component_MultiSelect, {
              modelValue: _ctx.form.selectedDiseases,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.selectedDiseases) = $event)),
              options: _ctx.diseases,
              optionLabel: "name",
              placeholder: "Infectious diseases",
              display: "chip",
              class: "w-100 mb-3"
            }, null, 8, ["modelValue", "options"]),
            _createVNode(_component_MultiSelect, {
              modelValue: _ctx.form.selectedOutbreak,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.selectedOutbreak) = $event)),
              options: _ctx.outbreak,
              optionLabel: "name",
              placeholder: "Epidemics and emerging infectious diseases",
              display: "chip",
              class: "w-100 mb-3"
            }, null, 8, ["modelValue", "options"]),
            _createVNode(_component_MultiSelect, {
              modelValue: _ctx.form.selectedNon_communicable,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.selectedNon_communicable) = $event)),
              options: _ctx.non_communicable,
              optionLabel: "name",
              placeholder: "Non-communicable diseases",
              display: "chip",
              class: "w-100 mb-3"
            }, null, 8, ["modelValue", "options"]),
            _createVNode(_component_MultiSelect, {
              modelValue: _ctx.form.selectedStrengthening,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.selectedStrengthening) = $event)),
              options: _ctx.strengthening,
              optionLabel: "name",
              placeholder: "Health systems strengthening",
              display: "chip",
              class: "w-100 mb-3"
            }, null, 8, ["modelValue", "options"]),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_Checkbox, {
                id: "reproductive",
                name: "reproductive",
                value: "Reproductive, maternal, newborn and child health",
                modelValue: _ctx.form.reproductive,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.reproductive) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_18
            ])
          ]),
          _createElementVNode("span", _hoisted_19, [
            _createVNode(_component_InputText, {
              type: "text",
              id: "other",
              name: "other",
              modelValue: _ctx.form.other,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.other) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_20
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _hoisted_22,
        _hoisted_23,
        _createElementVNode("span", _hoisted_24, [
          _createVNode(_component_InputText, {
            type: "text",
            id: "title",
            name: "title",
            modelValue: _ctx.form.title,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.title) = $event))
          }, null, 8, ["modelValue"]),
          _hoisted_25
        ]),
        _hoisted_26,
        _createVNode(_component_Textarea, {
          modelValue: _ctx.form.description,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.description) = $event)),
          id: "description",
          name: "description",
          autoResize: true,
          rows: "5",
          cols: "30",
          placeholder: "Enter text here...",
          class: "w-100"
        }, null, 8, ["modelValue"]),
        _hoisted_27,
        _createVNode(_component_Textarea, {
          modelValue: _ctx.form.innovative,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.innovative) = $event)),
          id: "innovative",
          name: "innovative",
          autoResize: true,
          rows: "5",
          cols: "30",
          placeholder: "Enter text here...",
          class: "w-100 mb-3"
        }, null, 8, ["modelValue"]),
        _hoisted_28,
        _createVNode(_component_Textarea, {
          modelValue: _ctx.form.similar,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.similar) = $event)),
          id: "similar",
          name: "similar",
          autoResize: true,
          rows: "5",
          cols: "30",
          placeholder: "Enter text here...",
          class: "w-100 mb-3"
        }, null, 8, ["modelValue"]),
        _hoisted_29,
        _hoisted_30,
        _createVNode(_component_Dropdown, {
          id: "solution",
          name: "solution",
          modelValue: _ctx.form.solution,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.solution) = $event)),
          options: _ctx.stageSolutionProp,
          optionLabel: "id",
          optionValue: "id",
          placeholder: "Select stage of solution development",
          class: "w-100 mb-3"
        }, null, 8, ["modelValue", "options"]),
        _hoisted_31,
        _createVNode(_component_Dropdown, {
          id: "clinical",
          name: "clinical",
          modelValue: _ctx.form.clinical,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.clinical) = $event)),
          options: _ctx.stageClinicalProp,
          optionLabel: "id",
          optionValue: "id",
          placeholder: "Select stage of clinical development (if applicable)",
          class: "w-100 mb-3"
        }, null, 8, ["modelValue", "options"]),
        _hoisted_32,
        _createVNode(_component_Dropdown, {
          id: "subject",
          name: "subject",
          modelValue: _ctx.form.subject,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.subject) = $event)),
          options: _ctx.stageSubjectProp,
          optionLabel: "id",
          optionValue: "id",
          placeholder: "Select solution subject to regulatory requirements?",
          class: "w-100 mb-3"
        }, null, 8, ["modelValue", "options"]),
        (_ctx.form.subject === 'Yes')
          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
              _hoisted_34,
              _createVNode(_component_Dropdown, {
                id: "requirement",
                name: "requirement",
                modelValue: _ctx.form2.requirement,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form2.requirement) = $event)),
                options: _ctx.requirementProp,
                optionLabel: "id",
                optionValue: "id",
                placeholder: "Select regulatory requirements",
                class: "w-100 mb-3 p-dropdown-sm"
              }, null, 8, ["modelValue", "options"]),
              _hoisted_35,
              _createVNode(_component_Textarea, {
                modelValue: _ctx.form2.regulatoryReqOthers,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form2.regulatoryReqOthers) = $event)),
                id: "regulatoryReqOthers",
                name: "regulatoryReqOthers",
                autoResize: true,
                rows: "5",
                cols: "30",
                placeholder: "Enter text here...",
                class: "w-100 mb-3"
              }, null, 8, ["modelValue"]),
              _hoisted_36,
              _createVNode(_component_Dropdown, {
                id: "status",
                name: "status",
                modelValue: _ctx.form2.status,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form2.status) = $event)),
                options: _ctx.statusProp,
                optionLabel: "id",
                optionValue: "id",
                placeholder: "Status of regulatory requirement of solution.",
                class: "w-100"
              }, null, 8, ["modelValue", "options"]),
              (
              _ctx.form2.status === 'Applied' ||
              _ctx.form2.status === 'Under consideration' ||
              _ctx.form2.status === 'Completed and valid'
            )
                ? (_openBlock(), _createBlock(_component_BaseFileLong, {
                    key: 0,
                    value: _ctx.fileProp,
                    file: _ctx.file,
                    "onUpdate:file": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.file) = $event))
                  }, null, 8, ["value", "file"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _hoisted_37,
        _createVNode(_component_Dropdown, {
          id: "fund",
          name: "fund",
          modelValue: _ctx.form.fund,
          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.fund) = $event)),
          options: _ctx.fundProp,
          optionLabel: "id",
          optionValue: "id",
          placeholder: "Select what funds have been raised to date, or what is organisation turnover?",
          class: "w-100 mb-3"
        }, null, 8, ["modelValue", "options"]),
        _hoisted_38,
        _createVNode(_component_Textarea, {
          modelValue: _ctx.form.employee,
          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.employee) = $event)),
          id: "employee",
          name: "employee",
          autoResize: true,
          rows: "5",
          cols: "30",
          placeholder: "Enter text here...",
          class: "w-100"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_39, [
        _createVNode(_component_BaseButton, {
          customStyle: _ctx.btnStyle,
          type: "button",
          onClick: _ctx.saveForLater
        }, {
          default: _withCtx(() => [
            _createTextVNode("Save for later")
          ]),
          _: 1
        }, 8, ["customStyle", "onClick"]),
        _createVNode(_component_BaseButton, {
          disabled: _ctx.loading,
          class: _normalizeClass({ submitting: _ctx.loading }),
          customStyle: _ctx.buttonStyle,
          type: "button",
          onClick: _withModifiers(_ctx.nextPage, ["prevent"])
        }, {
          default: _withCtx(() => [
            _createTextVNode("Next Page")
          ]),
          _: 1
        }, 8, ["disabled", "class", "customStyle", "onClick"])
      ])
    ], 512)
  ]))
}